import { render, staticRenderFns } from "./PageManagedContractPartners.vue?vue&type=template&id=4f3978b1&"
import script from "./PageManagedContractPartners.vue?vue&type=script&lang=js&"
export * from "./PageManagedContractPartners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports